import { render, staticRenderFns } from "./EnterpriseReviewTable.vue?vue&type=template&id=2f99f3ac&scoped=true&"
import script from "./EnterpriseReviewTable.vue?vue&type=script&lang=ts&"
export * from "./EnterpriseReviewTable.vue?vue&type=script&lang=ts&"
import style0 from "./EnterpriseReviewTable.vue?vue&type=style&index=0&id=2f99f3ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99f3ac",
  null
  
)

export default component.exports